export default "/images/991a73f47a1a20afcbaeca228991a86f.avif";